module.exports = __webpack_public_path__ + "img/satin-480-60.7bd641f3.jpg";